import React from "react";
import PropTypes from "prop-types";

// eslint-disable-next-line import/no-cycle
import StandardTabs from "./StandardTabs";
import ComponentMissing from "../../Debug/ComponentMissing";

const TabsSwitcher = ({
  layout,
  header,
  headerType,
  headerDisplayStyle,
  subline,
  tabContent,
  items,
}) => {
  const properties = {
    header,
    headerType,
    headerDisplayStyle,
    subline,
    tabContent,
    items,
  };

  function switchTabs() {
    switch (layout) {
      case "standard":
        return <StandardTabs properties={properties} />;
      default:
        return <ComponentMissing type="Tabs" subType={layout} />;
    }
  }

  return switchTabs();
};

TabsSwitcher.propTypes = {
  layout: PropTypes.string,
  header: PropTypes.string,
  headerType: PropTypes.string,
  headerDisplayStyle: PropTypes.string,
  subline: PropTypes.string,
  tabContent: PropTypes.instanceOf(Array),
  items: PropTypes.instanceOf(Object),
};

export default TabsSwitcher;
